import Spinner from "components/Spinner";
import React, { Suspense, lazy } from "react";
const FocusSheetEditor = lazy(() => import("components/FocusSheetEditor"));

const FocusSheet = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <FocusSheetEditor />{" "}
    </Suspense>
  );
};

export default FocusSheet;
